
class ArticleCategory {
    public id: string;
    public name: string;
    public description: string;
    public status: string;

    constructor(
        id: string,
        name: string,
        description: string,
        status: string,
    ) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.status = status;
    }
}

export default ArticleCategory;